<template>
	<div>

		<!-- -->
		<SideNavMobile  v-if="$store.getters['dom/isMobile'] || $store.getters['dom/isTablet']"
		class="mobile" :class="{scroll: scrollActive}"  :scroll="handleScroll" @ExlusiveContentShow="ExlusiveContentShow" key="2" data-aos="fade-down" />
		<SideNav
		v-else
		class="leftside"
		key="1"
		data-aos="fade-right"
		@ExlusiveContentShow="ExlusiveContentShow"
		 />

		<div class="rightside" key="3" data-aos="fade-up">

			<div
			class="home"
			v-scroll-spy="{ offset: 130 }"
			>
			<Hero/>
			<!-- <Discount /> -->
			<BenefitBottom />
			<SeatSelection />
			<AccountSummary />
			<PaymentInfo />
			<!-- <ImportantDates /> -->
			<!-- <Faq /> -->
			<ContactUs />

		</div>
	</div>

	<!-- <AppHeader></AppHeader> -->
	<AppFooter></AppFooter>
	<ExlusiveContent :ExlusiveContentActive="ExlusiveContentActive" @ExlusiveContentHide="ExlusiveContentHide" />
	<!-- <RepInfo :RepInfoActive="RepInfoActive" @RepInfoHide="RepInfoHide" /> -->
	<!-- <Invoice :InvoiceActive="InvoiceActive" @InvoiceHide="InvoiceHide" /> -->
</div>

</template>
<script>
// import AppHeader from "@/layout/Header.vue";
// import RepInfo from "@/layout/RepInfo";
import SideNav from "@/layout/SideNav.vue";
import SideNavMobile from "@/layout/SideNavMobile.vue";
import ExlusiveContent from "@/layout/ExlusiveContent";
import AppFooter from "@/layout/Footer.vue";
import Hero from "./Hero";
// import Discount from "./Discount";
import SeatSelection from "./SeatSelection";
import BenefitBottom from "./BenefitBottom";
import AccountSummary from "./AccountSummary";
// import ImportantDates from "./ImportantDates";
import PaymentInfo from "./PaymentInfo";
import ContactUs from "./ContactUs";

// import { reactive, toRefs, computed, watchEffect, onMounted } from "vue";
// import { useStore } from "vuex";

export default {
	components: {
		SideNav,
		SideNavMobile,
		AppFooter,
		Hero,
		// Discount,
		BenefitBottom,
		AccountSummary,
		SeatSelection,
		PaymentInfo,
		// ImportantDates,
		// Faq,
		ContactUs,
		ExlusiveContent,
	},
	created () {
		window.addEventListener('scroll', this.handleScroll);
	},
	// destroyed () {
	//   window.removeEventListener('scroll', this.handleScroll);
	// },

	// emit: [ "Invoice"],
	data() {
		return {

			// RepInfoActive: false,
			// InvoiceActive: false,
			scrollActive: false,
			ExlusiveContentActive: false,
		};
	},
	methods: {
		ExlusiveContentShow() {
			this.ExlusiveContentActive = true;
		},
		ExlusiveContentHide(){
			this.ExlusiveContentActive = false;
		},
		handleScroll: function (evt, el) {
	      if (window.scrollY > 200) {
	        this.scrollActive = true;
	      }
		  else{
			  this.scrollActive = false;
		  }
	      return window.scrollY > 100
	    }

		// handleScroll (event) {
		// 	console.log(event);
		// 	this.scrollActive = true;
		// 	// Any code to be executed when the window is scrolled
		// }
	},
};
</script>

<style lang="scss" scoped>
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.fade-fast-enter-active,
.fade-fast-leave-active {
	transition: opacity 1s ease-in-out;
}
.fade-fast-enter, .fade-fast-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.rightside {
	width: 100%;
	padding-left: 230px;
	@media (max-width: $lg) {
		width: 100%;
		padding-left: 0;
	}
}
.leftside {
	@include media-breakpoint-only(md) {
		display:none;
	}
	@media (min-width: $lg) {
		position: fixed;
		z-index: 999;
		width: 230px;
		height: 100vh;
		left: 0;
		top: 0;
		background-color: #0E3386;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: top;
		overflow: auto;
	}

	// @media (max-width: $lg) {
	//   position: fixed;
	//   width: 100%;
	//   // height: 50px;
	//   height: auto;
	//   border-right: none;
}
.mobile {
	z-index: 999;
	height: 60px;
	position: fixed;
	width: 100%;
	// left: 0;
	// top: 0;

	// background-image: url("~@/assets/images/backgrounds/bg-nav.png");
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top;

	padding: 5px 0;
	&.scroll{
		border-bottom: 10px solid #0E3386;
		background-color: #0E3386;
	}
}
</style>
